import React from 'react';

// GraphQl
import { useQuery } from '@apollo/react-hooks';

// Components & Others
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import LoadingIndicator from '../../../LoadingIndicator';
import EducationLevelForm from '../EducationLevelForm';
import { GET_EDUCATION_LEVEL } from '../queries';

function EducationLevelEdit() {
  const { id } = useParams();
  const history = useHistory();
  const { loading, error, data } = useQuery(GET_EDUCATION_LEVEL, {
    variables: { id },
  });
  if (loading) return <LoadingIndicator />;
  if (error) {
    console.error(error);
    history.goBack();
  }

  const formatValue = { ...data.educationLevel };
  if (!data.educationLevel) {
    history.goBack();
  }

  return <EducationLevelForm educationLevel={formatValue} id={id} isEdit />;
}

EducationLevelEdit.propTypes = {};

export default EducationLevelEdit;
